export const humanize = (timeInMs: number) => {
  const seconds = Math.round(timeInMs / 1000);
  const minutes = Math.round(seconds / 60);
  const hours = Math.round(minutes / 60);
  const days = Math.round(hours / 24);

  if (days > 1) {
    return `${days} days`;
  }
  if (hours > 0) {
    return `${hours} hours`;
  }
  if (minutes > 0) {
    return `${minutes} mins`;
  }
  return `${seconds} seconds`;
};
